import React from "react";
import {UseFormReturn, useWatch} from "react-hook-form";
import type {ExtractStringKeys} from "../../../../../react-commons/types/extractKeysOfType";
import {ImageContentDisplay} from "./ImageContentDisplay";

export const FormImageContentDisplay = <T extends object>({
    projectVersionId,
    name,
    form,
}: {
    projectVersionId: string | undefined | null;
    form: UseFormReturn<T>;
    name: ExtractStringKeys<T, false>;
}) => {
    const imageWatcher = useWatch({
        control: form.control,
        name
    })

    return <ImageContentDisplay imageAttachmentObjectId={imageWatcher} versionedIn={projectVersionId ?? ""} height={null}/>
};